import { lazy } from 'react'
import { RouteProps } from 'react-router'

export interface PrivateRouteObject extends RouteProps {
  exact: boolean
  path: string
  breadcrumb: string
  component: any
  title: string
  hidePageWrap?: boolean
}

const Login = lazy(() => import('../containers/Login'))
const Register = lazy(() => import('../containers/Register'))
const ConfirmEmail = lazy(() => import('../containers/ConfirmEmail'))
const ForgotPassword = lazy(() => import('../containers/ForgotPassword'))
const ResetPassword = lazy(() => import('../containers/ResetPassword'))

const CreateAccount = lazy(() => import('../containers/CreateAccount'))
const AppDownload = lazy(() => import('../containers/AppDownload'))
const Settings = lazy(() => import('../containers/Settings'))
const MyTasks = lazy(() => import('../containers/MyTasks'))
const ReportTasks = lazy(() => import('../containers/ReportTasks'))
const ReportTask = lazy(() => import('../containers/ReportTask'))
const VerifyOtp = lazy(() => import('../containers/VerifyOtp'))

const PRIVATE_ROUTES: PrivateRouteObject[] = [
  {
    exact: true,
    title: 'My Activities',
    path: '/auth/my-activities',
    component: MyTasks,
    breadcrumb: 'My Activities'
  },
  {
    exact: true,
    title: 'Report Tasks',
    path: '/auth/report-tasks',
    component: ReportTasks,
    breadcrumb: 'Report Tasks'
  },
  {
    exact: true,
    title: 'Report Task',
    path: '/auth/report-tasks/:taskId',
    component: ReportTask,
    breadcrumb: 'Report Task'
  },
  {
    exact: true,
    title: 'Settings',
    path: '/auth/settings',
    component: Settings,
    breadcrumb: 'Settings'
  }
]

const PUBLIC_ROUTES = [
  {
    exact: true,
    title: 'Home',
    path: '/',
    component: Login
  },
  {
    exact: true,
    title: 'Login',
    path: '/login',
    component: Login
  },
  {
    exact: true,
    title: 'Register',
    path: '/register',
    component: Register
  },
  {
    exact: true,
    title: 'Confirm Email',
    path: '/confirm-email',
    component: ConfirmEmail
  },
  {
    exact: true,
    title: 'Forgot Password',
    path: '/forgot-password',
    component: ForgotPassword
  },

  {
    exact: true,
    title: 'Reset Password',
    path: '/reset-password',
    component: ResetPassword
  },
  {
    exact: true,
    title: 'Create your account',
    path: '/create-account',
    component: CreateAccount
  },
  {
    exact: true,
    title: 'Download app',
    path: '/app-download',
    component: AppDownload
  },
  {
    exact: true,
    title: 'Verify OTP',
    path: '/verify-otp',
    component: VerifyOtp
  }
]

export { PUBLIC_ROUTES, PRIVATE_ROUTES }
